// extracted by mini-css-extract-plugin
export default {"AdSlotOffsite":"bgq_a bhp_bi"};